export const TIPOS = ["triple", "animalitos", "lotto", "rifas", "raspaditos"];

// Tipos de juego visibles (catálogo de arranque SORTIVEN V1.4).
export const VISIBLE_TIPOS = ["triple", "animalitos"];

// Indica si un tipo de juego debe mostrarse en la interfaz (público + consola).
export const isVisibleTipo = (tipo) => VISIBLE_TIPOS.includes(tipo);

export const TIPO_LABEL = {
  triple: "TripleFalcón Venezuela",
  animalitos: "ZooloFalcón Venezuela",
  lotto: "Lotto",
  rifas: "Rifa",
  raspaditos: "Raspadito",
};

export const ESTADO_LABEL = {
  comprometido: "Comprometido",
  ejecutado: "Ejecutado",
  revelado: "Revelado",
};

export function truncateHash(h, n = 10) {
  if (!h) return "—";
  if (h.length <= n * 2 + 3) return h;
  return `${h.slice(0, n)}…${h.slice(-n)}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-VE", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatResultado(tipo, resultado) {
  if (resultado === null || resultado === undefined) return "—";
  if (tipo === "triple") {
    return `A ${resultado.triple_a} · B ${resultado.triple_b} · ${resultado.estado}`;
  }
  if (tipo === "lotto") return resultado.join("  ·  ");
  if (tipo === "rifas") return resultado.map((x) => `#${x}`).join("  ·  ");
  if (tipo === "animalitos") {
    return `${resultado.numero} · ${resultado.figura}${resultado.comodin ? " (COMODÍN)" : ""}`;
  }
  if (tipo === "raspaditos") return resultado.premio;
  return String(resultado);
}
